import Vue from 'vue';

/**
 * Initializes vue and all its components
 */
export default class VueApplication {
	static init() {
		Vue.prototype.$eventHub = new Vue();

		Vue.component('collapse-fiona', require('../components/CollapseFiona.vue').default);
		Vue.component('collapse-fiona-item', require('../components/CollapseFionaItem.vue').default);

		return new VueApplication();
	}

	constructor() {
		const vueElements = document.querySelectorAll('.bard__module.collapse_fiona');

		if (vueElements.length === 0) {
			return;
		}

		vueElements.forEach((el) => {
			new Vue({
				el: el,
				mounted() {
					let anchorID = window.location.hash.substring(1);
					let anchorElement = anchorID.length > 0 ? document.querySelector(`#${anchorID}`) : null;

					if (anchorID && anchorElement)
						anchorElement.scrollIntoView();
				}
			});
		});
	}
}
